
import React, { useEffect, useState, forwardRef, useRef } from "react";
// import ReactToPrint, { PrintContextConsumer, useReactToPrint } from "react-to-print";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { Link, useNavigate } from "react-router-dom";
import {
    Box, Button, Grid, Dialog, DialogTitle, TextField, DialogActions, Container, Popover,
    TablePagination, Typography, InputAdornment, IconButton, DialogContent, Divider, Snackbar
} from '@mui/material';
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Icon } from '@iconify/react';
import EditIcon from '@mui/icons-material/Edit';
import { SearchOutlined } from '@mui/icons-material';
// import { downloadExcel } from 'react-export-table-to-excel';
import BackBtn from "../../reusableComponent/BackBtn";
import { useDispatch, useSelector } from "react-redux";
import { editDeleteCNS, editDeleteUnit, getCNSList, getUnitList } from "../../../actions/actions";
import styles from '.././../../styles.module.css';
import {
    PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, LineChart, Line,
    CartesianGrid, Tooltip, Legend, ResponsiveContainer, ComposedChart, Scatter
} from 'recharts';
import SalesHome from "./SalesHome";
import Breadcrumb from "../../reusableComponent/Breadcrumb";


// ratio --------------
const dataratio = [
    { index: 10000, red: 1643, blue: 790 },
    { index: 1666, red: 182, blue: 42 },
    { index: 625, red: 56, blue: 11 },
    // Calculation of line of best fit is not included in this demo
    { index: 300, redLine: 0 },
    { index: 10000, redLine: 1522 },
    { index: 600, blueLine: 0 },
    { index: 10000, blueLine: 678 },
];
// line chart ---------------
const series = [
    {
        name: 'Series 1',
        data: [
            { category: 'A', value: Math.random() },
            { category: 'B', value: Math.random() },
            { category: 'C', value: Math.random() },
        ],
    },
    {
        name: 'Series 2',
        data: [
            { category: 'B', value: Math.random() },
            { category: 'C', value: Math.random() },
            { category: 'D', value: Math.random() },
        ],
    },
    {
        name: 'Series 3',
        data: [
            { category: 'C', value: Math.random() },
            { category: 'D', value: Math.random() },
            { category: 'E', value: Math.random() },
        ],
    },
];
// bar-----
const Bardata = [
    {
        name: 'Page A',
        quotation: 4000,
        sales: 2400,
        amt: 2400,
    },
    {
        name: 'Page B',
        quotation: 3000,
        sales: 1398,
        amt: 2210,
    },
    {
        name: 'Page C',
        quotation: 2000,
        sales: 9800,
        amt: 2290,
    },

];

// -------------------------
const RADIAN = Math.PI / 180;
const data = [
    { name: 'A', value: 80, color: '#ff0000' },
    { name: 'B', value: 45, color: '#00ff00' },
    { name: 'C', value: 25, color: '#0000ff' },
];
const cx = 120;
const cy = 100;
const iR = 50;
const oR = 80;
const value = 90;

const needle = (value, data, cx, cy, iR, oR, color) => {
    let total = 0;
    data.forEach((v) => {
        total += v.value;
    });
    const ang = 180.0 * (1 - value / total);
    const length = (iR + 2 * oR) / 3;
    const sin = Math.sin(-RADIAN * ang);
    const cos = Math.cos(-RADIAN * ang);
    const r = 5;
    const x0 = cx + 5;
    const y0 = cy + 5;
    const xba = x0 + r * sin;
    const yba = y0 - r * cos;
    const xbb = x0 - r * sin;
    const ybb = y0 + r * cos;
    const xp = x0 + length * cos;
    const yp = y0 + length * sin;

    return [
        <circle cx={x0} cy={y0} r={r} fill={color} stroke="none" />,
        <path d={`M${xba} ${yba}L${xbb} ${ybb} L${xp} ${yp} L${xba} ${yba}`} stroke="#none" fill={color} />,
    ];
};

function SalesDashboard(props, interval) {
    const dispatch = useDispatch();

    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;







    const rows = useSelector(state => state.CNS.CNS)
    const fetchData = () => {
        dispatch(getCNSList({ financialYear: userInfo.financialYear, companyId: userInfo.companyId, CNS_Type: 'Customer' }))
    };
    useEffect(() => {
        fetchData()
    }, []);
    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.CNS.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                // setSuccessMessage(responseMessage);
                setShouldShowMsg(false);
                dispatch({ type: 'RESET_MESSAGE' });
                fetchData();
            }
        }
    }, [shouldShowMsg, responseMessage, fetchData]);




    return (
        <>
          <Breadcrumb
                routeSegments={[
                    { name: 'Sales', },
                ]}
            />
            <SalesHome />
            <Paper className={`${styles.gradient_banner}`}>
                <Box sx={{ justifyContent: 'center', }}>
                    <Typography style={{ fontSize: '30px', fontWeight: 'bold', textAlign: 'center' }}> <span style={{ borderBottom: '5px solid #14516f' }}> Sales Performance </span></Typography>
                </Box>
                <Box style={{ margin: '18px', }}>
                    <Grid container spacing={1} sx={{}}>
                        <Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', borderRight: '1px dashed #1294ff', borderBottom: '1px dashed #1294ff' }}>
                            <Box className={`${styles.sale_home_card}`}>
                                <Typography className={`${styles.sale_home_lable}`} style={{ fontSize: '16px', fontWeight: 'bold', textAlign: 'center' }}>Total Revenue</Typography>
                                <Typography className={`${styles.sale_home_lable}`} style={{ textAlign: 'center' }}>$7699.76</Typography>
                                <PieChart width={250} height={150}>
                                    <Pie
                                        dataKey="value"
                                        startAngle={180}
                                        endAngle={0}
                                        data={data}
                                        cx={cx}
                                        cy={cy}
                                        innerRadius={iR}
                                        outerRadius={oR}
                                        fill="#8884d8"
                                        stroke="none"
                                    >
                                        {data.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={entry.color} />
                                        ))}
                                    </Pie>
                                    {needle(value, data, cx, cy, iR, oR, '#d0d000')}
                                </PieChart>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', borderRight: '1px dashed #1294ff', borderBottom: '1px dashed #1294ff' }}>
                            <Box className={`${styles.sale_home_card}`}>
                                <Typography className={`${styles.sale_home_lable}`} style={{ fontSize: '16px', fontWeight: 'bold', textAlign: 'center' }}>Profit Margin</Typography>
                                <Typography className={`${styles.sale_home_lable}`} style={{ textAlign: 'center' }}>6 %</Typography>

                                <LineChart width={300} height={150}>
                                    <XAxis dataKey="category" type="category" allowDuplicatedCategory={false} />
                                    <YAxis dataKey="value" />
                                    <Tooltip />
                                    <Legend />
                                    {series.map((s) => (
                                        <Line dataKey="value" data={s.data} name={s.name} key={s.name} />
                                    ))}
                                </LineChart>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', borderBottom: '1px dashed #1294ff' }}>
                            <Box className={`${styles.sale_home_card}`}>
                                <Typography className={`${styles.sale_home_lable}`} style={{ fontSize: '16px', fontWeight: 'bold', textAlign: 'center' }}>Sales Growth</Typography>
                                <Typography className={`${styles.sale_home_lable}`} style={{ textAlign: 'center' }}>16%</Typography>
                                <BarChart
                                    width={300}
                                    height={150}
                                    data={Bardata}
                                    margin={{
                                        top: 5,
                                        right: 30,
                                        left: 20,
                                        bottom: 5,
                                    }}
                                >
                                    {/* <CartesianGrid strokeDasharray="3 3" /> */}
                                    {/* <XAxis dataKey="name" /> */}
                                    {/* <YAxis /> */}
                                    <Tooltip />
                                    <Legend />
                                    <Bar dataKey="quotation" fill="#8884d8" />
                                    <Bar dataKey="sales" fill="#82ca9d" />
                                </BarChart>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', borderRight: '1px dashed #1294ff' }}>
                            <Box className={`${styles.sale_home_card}`}>
                                <Typography className={`${styles.sale_home_lable}`} style={{ fontSize: '16px', fontWeight: 'bold', textAlign: 'center' }}>Closing Ratio</Typography>
                                <Typography className={`${styles.sale_home_lable}`} style={{ textAlign: 'center' }}>14%</Typography>
                                <ComposedChart
                                    width={300}
                                    height={150}
                                    data={dataratio}
                                    margin={{
                                        top: 20,
                                        right: 80,
                                        bottom: 20,
                                        left: 20,
                                    }}
                                >
                                    {/* <CartesianGrid stroke="#f5f5f5" /> */}
                                    <Tooltip />
                                    <Legend />

                                    <XAxis dataKey="index" type="number" label={{ value: 'Index', position: 'insideBottomRight', offset: 0 }} />
                                    <YAxis unit="ms" type="number" label={{ value: 'Time', angle: -90, position: 'insideLeft' }} />
                                    <Scatter name="red" dataKey="red" fill="red" />
                                    <Scatter name="blue" dataKey="blue" fill="blue" />
                                    <Line dataKey="blueLine" stroke="blue" dot={false} activeDot={false} legendType="none" />
                                    <Line dataKey="redLine" stroke="red" dot={false} activeDot={false} legendType="none" />
                                </ComposedChart>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', borderRight: '1px dashed #1294ff' }}>
                            <Box className={`${styles.sale_home_card}`}>
                                <Typography className={`${styles.sale_home_lable}`} style={{ fontSize: '16px', fontWeight: 'bold', textAlign: 'center' }}>Sales Cycle Length</Typography>
                                <Typography className={`${styles.sale_home_lable}`} style={{ textAlign: 'center' }}>90 Days</Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                            <Box className={`${styles.sale_home_card}`}>
                                <Typography className={`${styles.sale_home_lable}`} style={{ fontSize: '16px', fontWeight: 'bold', textAlign: 'center' }}>NPS</Typography>
                                <Typography className={`${styles.sale_home_lable}`} style={{ textAlign: 'center' }}> + 8</Typography>
                                <PieChart width={250} height={150}>
                                    <Pie
                                        dataKey="value"
                                        startAngle={180}
                                        endAngle={0}
                                        data={data}
                                        cx={cx}
                                        cy={cy}
                                        innerRadius={iR}
                                        outerRadius={oR}
                                        fill="#8884d8"
                                        stroke="none"
                                    >
                                        {data.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={entry.color} />
                                        ))}
                                    </Pie>
                                    {needle(value, data, cx, cy, iR, oR, '#d0d000')}
                                </PieChart>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Paper>
        </>
    )
}

export default SalesDashboard